import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import SEO from "../components/SEO";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function AdminLogin() {
  const nav = useNavigate();
  // `api` is a stable module singleton
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    api.get("/auth/me").then(() => nav("/admin", { replace: true })).catch(() => {});
  }, [nav]);

  const login = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4">
      <SEO title="Admin | Driver Reborn Advisory" description="" noindex={true} />
      <div className="max-w-md w-full border border-[#2B2B2B] bg-[#111111] p-8">
        <div className="text-[#FF6A00] text-xs uppercase tracking-widest mb-2">Internal Access</div>
        <h1 className="font-bebas text-4xl uppercase leading-none mb-4" data-testid="admin-login-title">Driver Reborn Advisory — Admin</h1>
        <p className="text-sm text-[#A1A1AA] mb-6">
          Sign in with the owner Google account. Only allowlisted emails receive admin access.
        </p>
        <button onClick={login} className="btn-primary w-full justify-center" data-testid="admin-login-btn">
          Continue with Google
        </button>
      </div>
    </div>
  );
}

export function AuthCallback() {
  const nav = useNavigate();
  const processedRef = React.useRef(false);
  const [error, setError] = useState("");
  // `api` is a stable module singleton; hash read once via ref guard
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (processedRef.current) return;
    processedRef.current = true;
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace("#", ""));
    const session_id = params.get("session_id");
    if (!session_id) { nav("/admin/login", { replace: true }); return; }
    api.post("/auth/session", { session_id })
      .then(() => nav("/admin", { replace: true }))
      .catch((e) => setError(e?.response?.data?.detail || "Login failed"));
  }, [nav]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        {error ? (
          <>
            <h1 className="font-bebas text-3xl uppercase mb-2 text-[#EF4444]" data-testid="auth-error">Access denied</h1>
            <p className="text-[#A1A1AA] mb-4">{error}</p>
            <button onClick={() => nav("/admin/login")} className="btn-ghost">Try another account</button>
          </>
        ) : (
          <p className="text-[#A1A1AA]" data-testid="auth-processing">Signing you in…</p>
        )}
      </div>
    </div>
  );
}
